import { subscriptionActions } from './subscriptionSlice'
import { fetchCachedHelper, fetchHelper } from '../../../api/api'

const getPlanDetails = async id => {
    const subscriptionRes = await fetchCachedHelper(`Subscriptionplan/${id}`)
    return subscriptionRes.data
}

export const getCurrentSub = email => async dispatch => {
    dispatch(subscriptionActions.getCurrentSubRequest())
    try {
        const response = await fetchHelper(
            `Customersubscription/GetActivePlan/${email}`
        )
        const activePlan = response.data
        const subscriptionId = activePlan.subid
        activePlan.subscription = await getPlanDetails(subscriptionId)
        dispatch(subscriptionActions.getCurrentSubRequestSuccess(activePlan))
    } catch (e) {
        dispatch(subscriptionActions.getCurrentSubRequestError(e.message))
    }
}

export const getSubHistory = email => async dispatch => {
    dispatch(subscriptionActions.getSubHistoryRequest())
    try {
        const response = await fetchHelper(
            `Customersubscription/SubHistory/${email}`
        )
        let history = response.data
        const planDetails = Promise.all(
            history.map(({ subid }) => getPlanDetails(subid))
        )
        const planPrices = Promise.all(
            history.map(
                ({ reference }) =>
                    reference &&
                    fetchCachedHelper(
                        `Paymentlog/GetPaymentsByRef/${reference}`
                    ) //Remove in prod because reference should never be null
            )
        )

        const [detailsRes, pricesRes] = await Promise.all([
            planDetails,
            planPrices,
        ])

        history = history.map((payment, idx) => {
            payment.subscription = detailsRes[idx]
            payment.log = pricesRes[idx]?.data || {} //Remove in prod because reference should never be null
            return payment
        })

        dispatch(subscriptionActions.getSubHistoryRequestSuccess(history))
    } catch (e) {
        console.error(e)
        dispatch(subscriptionActions.getSubHistoryRequestError(e.message))
    }
}
